import CornDensity from './corn-density';
import CornDiseaseControl from './corn-disease-control';
import DefensiveProfile from './defensive-profile';
import Features from './features';
import { CornFertilization } from './fertilization';
import NutritionalInfo from './nutritional-info';
import PestControl from './pest-control';
import { hasPestControlPlans } from './pest-control/has-pest-control-plans';
import { CornPhenology } from './phenology';
import Refuge from './refuge';

const CornInformationModules = [
    {
        component: CornDensity,
        condition: ({ productRecommendations }) =>
            productRecommendations.some(
                ({ harvestDensity, profile }) => Boolean(harvestDensity) || profile.densityTableValues.length > 0
            ),
    },
    {
        component: CornPhenology,
        condition: ({ productRecommendations }) => productRecommendations.some(({ phenology }) => Boolean(phenology)),
    },
    {
        component: CornFertilization,
        condition: ({ productRecommendations }) =>
            productRecommendations.some(({ estimatedYield }) => Boolean(estimatedYield.forRecommendedHarvestDensity)),
    },
    {
        component: DefensiveProfile,
        condition: ({ productRecommendations }) =>
            productRecommendations.find(({ profile }) => profile.metrics.length > 0),
    },
    {
        component: Features,
        condition: ({ productRecommendations }) =>
            productRecommendations.find(({ profile }) => profile.features.length > 0),
    },
    {
        component: NutritionalInfo,
        condition: ({ productRecommendations }) =>
            productRecommendations.some(({ profile }) => profile.nutritionalInfo && profile.nutritionalInfo.length > 0),
    },
    {
        component: CornDiseaseControl,
        condition: ({ productRecommendations }) =>
            productRecommendations.find(({ profile }) => profile.diseases.length > 0),
    },
    {
        component: PestControl,
        condition: ({ cropConfig }) => hasPestControlPlans(cropConfig.pestControlPlans),
    },
    {
        component: Refuge,
        condition: ({ productRecommendations }) =>
            productRecommendations.find(({ profile }) => !!profile.refugeOptions.length),
    },
];

export default CornInformationModules;
